$('.tag[data-menu-id] a').on('click', function() {  
  $('.tag').removeClass('tag--active');
  var thishashid = this.hash;
    var thishasspli = thishashid.split('#');
    $('html, body').animate({scrollTop: $('div[data-marker-id="'+thishasspli[1]+'"]').offset().top - 50}, 1000); 
   $(this).parent('.tag').addClass('tag--active');
});

// reset mobile menu:

function resetMobileMenu() {
  const _close_button = document.querySelector(".drawer__close-button");

  _close_button.addEventListener("click", () => {
    const _all_opened = document.querySelectorAll(
      ".tmenu_app .tmenu_item_active"
    );
    const _reversed_list = [..._all_opened].reverse();

    _reversed_list.forEach((item) => {
      // item.classList.remove('tmenu_item_active')
      if (item.firstChild) {
        item.firstChild.click();
      }
    });
  });
}

function backdropClicked() {
  const _site_nav__link = document.querySelector(
    ".site-nav__link.js-drawer-open-nav"
  );
  _site_nav__link.addEventListener("click", () => {
    const _backgrop = document.querySelector(".js-drawer-open.lock-scroll");

    _backgrop.addEventListener("click", () => {
      const _all_opened = document.querySelectorAll(
        ".tmenu_app .tmenu_item_active"
      );
      const _reversed_list = [..._all_opened].reverse();
  
      _reversed_list.forEach((item) => {
        // item.classList.remove('tmenu_item_active')
        if (item.firstChild) {
          item.firstChild.click();
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  resetMobileMenu();
  backdropClicked();
});
